module.exports = __webpack_public_path__ + "static/bar01_2_mobile-20a8498aa4b0e65a34d89472e5851120.png";